<div class="folder-content-table-container">
  <ipo-flexible-table
    [dataSet]="folderContent.items | mapId: mapTableId"
    [columns]="columns | translateArray: (language$ | async)! : 'header'"
    [clickableRows]="true"
    (rowClicked)="handleOnClick($event)"
  >
    <ng-template ipoTableColumn="icon" let-item>
      <gc-icon
        [iconName]="item.type === 'FOLDER' ? 'folder' : 'file'"
        [color]="item.type === 'FOLDER' ? 'caution' : 'primary'"
      ></gc-icon>
    </ng-template>
    <ng-template ipoTableColumn="name" let-item>
      {{ item.name }}
    </ng-template>
    <ng-template ipoTableColumn="modified" let-item>
      {{ formatDate(item.modifiedAt) }}
    </ng-template>
    <ng-template ipoTableColumn="size" let-item>
      {{ generateSizeString(item) }}
    </ng-template>
    <ng-template ipoTableColumn="button" let-item>
      <gc-icon
        [iconName]="item.type === 'FOLDER' ? 'chevronRight' : 'download'"
      ></gc-icon>
    </ng-template>
  </ipo-flexible-table>
</div>
